import { Outlet, Link, useLocation } from "react-router-dom";
import { Leaf, LayoutDashboard, Building2, FileBarChart2, Users, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const BASE_NAV = [
  { to: "/", label: "Panel", icon: LayoutDashboard, exact: true },
  { to: "/organizations", label: "Tesisler", icon: Building2 },
  { to: "/reports", label: "Raporlar", icon: FileBarChart2 },
];

export default function Layout() {
  const loc = useLocation();
  const { user, logout, isAdmin } = useAuth();
  const NAV = isAdmin ? [...BASE_NAV, { to: "/admin/users", label: "Kullanıcılar", icon: Users }] : BASE_NAV;
  return (
    <div className="min-h-screen flex bg-background">
      <aside className="hidden md:flex w-64 flex-col border-r border-border bg-card/40 sticky top-0 h-screen">
        <div className="px-6 pt-8 pb-6 border-b border-border">
          <div className="flex items-center gap-3">
            <div className="size-10 rounded-xl bg-primary text-primary-foreground flex items-center justify-center shadow-lg shadow-primary/20">
              <Leaf className="size-5" strokeWidth={2.2} />
            </div>
            <div>
              <div className="font-display text-[20px] font-semibold leading-tight text-primary">
                Karbon İzi
              </div>
              <div className="text-[11px] tracking-wide text-muted-foreground uppercase">
                ISO 14064-1:2018
              </div>
            </div>
          </div>
        </div>

        <nav className="px-3 py-6 space-y-1 flex-1">
          {NAV.map((item) => {
            const active = item.exact ? loc.pathname === item.to : loc.pathname.startsWith(item.to);
            const Icon = item.icon;
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`nav-${item.label.toLowerCase()}`}
                className={`group flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-all ${
                  active
                    ? "bg-primary text-primary-foreground shadow-md shadow-primary/20"
                    : "text-foreground/75 hover:bg-secondary hover:text-foreground"
                }`}
              >
                <Icon className="size-4" strokeWidth={active ? 2.4 : 1.8} />
                <span className="font-medium">{item.label}</span>
              </Link>
            );
          })}
        </nav>

        {/* User panel */}
        <div className="px-3 py-4 border-t border-border space-y-2">
          <div className="px-3 py-2">
            <div className="text-xs text-muted-foreground">Oturum</div>
            <div className="text-sm font-medium truncate" title={user?.email}>{user?.name || user?.email}</div>
            {isAdmin && <div className="text-[10px] uppercase tracking-wide text-[#2F5D3D] font-semibold mt-0.5">Admin</div>}
          </div>
          <button onClick={logout}
                  className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-foreground/75 hover:bg-secondary hover:text-foreground transition-colors"
                  data-testid="logout-btn">
            <LogOut className="size-4" /> Çıkış
          </button>
        </div>

        <div className="p-4 text-[11px] text-muted-foreground border-t border-border">
          <div className="font-medium text-foreground/80 mb-1">Veri Kaynakları</div>
          DEFRA 2025, IEA 2019, IPCC AR6
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 inset-x-0 z-40 bg-card/90 backdrop-blur border-b border-border px-4 py-3 flex items-center gap-3">
        <div className="size-9 rounded-lg bg-primary text-primary-foreground flex items-center justify-center">
          <Leaf className="size-4" />
        </div>
        <div className="flex-1">
          <div className="font-display text-[16px] font-semibold leading-tight text-primary">
            Karbon İzi
          </div>
        </div>
        <div className="flex gap-1">
          {NAV.map((i) => (
            <Link key={i.to} to={i.to} className="p-2 rounded-md hover:bg-secondary">
              <i.icon className="size-4" />
            </Link>
          ))}
          <button onClick={logout} className="p-2 rounded-md hover:bg-secondary" data-testid="logout-btn-mobile">
            <LogOut className="size-4" />
          </button>
        </div>
      </div>

      <main className="flex-1 md:ml-0 pt-16 md:pt-0 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
